import emojiData from "@emoji-mart/data";
import EmojiPicker from "@emoji-mart/react";
import { Popover } from "@jugl-web/ui-kit";
import { FC } from "react";
import { useEditorToolbar } from "../../../common/components/RichTextarea";
import { ReactComponent as BoldIcon } from "./assets/bold.svg";
import { ReactComponent as EmojiIcon } from "./assets/emoji.svg";
import { ReactComponent as ItalicIcon } from "./assets/italic.svg";
import { ReactComponent as StrikeIcon } from "./assets/strike.svg";
import { ToolbarButton } from "./components/ToolbarButton";
import { VariablesPopover } from "./components/VariablesPopover";
import { useSupportedWhatsappVariables } from "../../hooks";

interface ComponentProps {
  hideVariables?: boolean;
  entityId: string;
  boardId?: string;
}

export const WhatsAppTemplateEditorToolbar: FC<ComponentProps> = ({
  hideVariables,
  entityId,
  boardId,
}) => {
  const { toolbarState, formatSelection, insertText, insertVariable } =
    useEditorToolbar();
  const { variables } = useSupportedWhatsappVariables(entityId, boardId);

  return (
    <div className="mt-2 flex w-full items-center gap-4">
      <Popover
        placement="right-start"
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger ref={triggerRef} as={ToolbarButton} isActive={isOpen}>
            <EmojiIcon />
          </Trigger>
        )}
      >
        {({ onClose }) => (
          <EmojiPicker
            theme="light"
            data={emojiData}
            skinTonePosition="none"
            previewPosition="none"
            onEmojiSelect={(e: { native: string }) => {
              insertText(e.native);
              onClose();
            }}
          />
        )}
      </Popover>
      <ToolbarButton
        isActive={toolbarState.isBold}
        onClick={() => formatSelection("bold")}
      >
        <BoldIcon />
      </ToolbarButton>
      <ToolbarButton
        isActive={toolbarState.isItalic}
        onClick={() => formatSelection("italic")}
      >
        <ItalicIcon />
      </ToolbarButton>
      <ToolbarButton
        isActive={toolbarState.isStrikethrough}
        onClick={() => formatSelection("strikethrough")}
      >
        <StrikeIcon />
      </ToolbarButton>
      {!hideVariables && (
        <VariablesPopover
          variables={variables}
          onVariableSelect={insertVariable}
        />
      )}
    </div>
  );
};
